/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : architectureTypesReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Reducer } from "redux";
import actionType from "../actionTypes";
import customConsole from "../../config/customConsole";

const initialState = {
  error: false,
  msg: "",
  architectureTypesData: [],
};

const architectureTypesReducer = (state = initialState, action) => {
  customConsole(action);
  switch (action.type) {
    case actionType.ADD_ARCHITECTURE_TYPES:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    // case actionType.GET_ZONE:
    //   return {
    //     ...state,
    //     error: action.payload.error,
    //     msg: action.payload.msg,
    //     architectureTypesData: action.payload,
    //   };

    case actionType.DELETE_ARCHITECTURE_TYPES:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
      };
    // case actionType.UPDATE_ZONE:
    //   return {
    //     ...state,
    //     error: action.payload.error,
    //     msg: action.payload.msg,
    //   };
    default:
      return state;
  }
};

export default architectureTypesReducer;
